import React, { useEffect, useState } from 'react';
import { MDBContainer, } from 'mdb-react-ui-kit';
import BreadCrumbs from '../components/breadcrumbs';
import Banner from '../components/img_banner';
import Info from '../components/services_mbs_info';
import Desc from '../components/services_mbs_desc';

import DownContact from '../components/downcontact';
import RCMcy from '../images/servicesMain_Banner/medical-billing-services-icons2.webp';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
ReactGA.initialize('G-7WQFXCQFVP');

const MedicalBillingService = () => {
  useEffect(() => {
    // change title of page
    document.title = 'Professional Healthcare Medical Billing - USA - AcerHealth';
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7WQFXCQFVP';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-7WQFXCQFVP');
  }, []);

  // Set breadcrumb
  const [Breadcrumb, setBreadcrumb] = useState('Medical Billing Services');

  // Set Banner Title
  const [BannerTitle, setBannerTitle] = useState({ title: "Medical Billing Services", subtitle: "Effortlessly Secure Pre-authorizations, Streamline Processes, and Prevent Payment Delays with Us.", img: `url(${RCMcy})` });

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({ title: "Partner with AcerHealth—recognized as one of the leading medical billing companies in the USA—for reliable, transparent, and comprehensive medical billing services that strengthen revenue cycle performance and compliance." });


  return (
    <>
      <Helmet>
        <title>Medical Billing Services in USA – Reduce Denials | AcerHealth</title>
        <link rel="canonical" href="https://acerhealth.com/services/medical-billing-services" />
        <meta name="description" content="End-to-end medical billing services in the USA with denial management, AR follow-up, and HIPAA-compliant RCM for faster reimbursements." />
        <meta name="keywords" content="Medical Billing Service" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [

              {
                "@type": "Organization",
                "name": "AcerHealth",
                "url": "https://acerhealth.com",
                "logo": "%PUBLIC_URL%/favicon.png",
                "sameAs": [
                  "https://www.linkedin.com/company/acerhealth",
                  "https://www.facebook.com/acerhealth1"
                ]
              },

              {
                "@type": "Service",
                "name": "Medical Billing Services in USA",
                "provider": {
                  "@type": "Organization",
                  "name": "AcerHealth"
                },
                "url": "https://acerhealth.com/services/medical-billing-services",
                "description": "End-to-end medical billing services in the USA including claim submission, denial management, AR follow-up, payment posting, and HIPAA-compliant revenue cycle management.",
                "areaServed": {
                  "@type": "Country",
                  "name": "United States"
                },
                "serviceType": "Medical Billing and Revenue Cycle Management",
                "offers": {
                  "@type": "Offer",
                  "availability": "https://schema.org/InStock"
                }
              },

              {
                "@type": "LocalBusiness",
                "name": "AcerHealth",
                "url": "https://acerhealth.com",
                "image": "https://acerhealth.com/static/media/acerhealth%20website%20logo.fd4c90a263acfb6cef0098605eeffbd6.svg",
                "address": {
                  "@type": "PostalAddress",
                  "addressRegion": "VA",
                  "addressCountry": "US"
                },
                "areaServed": {
                  "@type": "Country",
                  "name": "United States"
                },
                "serviceArea": {
                  "@type": "AdministrativeArea",
                  "name": "Virginia"
                },
                "sameAs": [
                  "https://www.linkedin.com/company/acerhealth",
                  "https://www.facebook.com/acerhealth1"
                ],
                "description": "AcerHealth provides medical billing services in the USA including denial management, accounts receivable follow-up, payment posting, and HIPAA-compliant revenue cycle management for healthcare providers.",
                "makesOffer": {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Medical Billing Services in USA"
                  }
                }
              },

              {
                "@type": "FAQPage",
                "mainEntity": [

                  {
                    "@type": "Question",
                    "name": "Do you provide medical billing services in the USA?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth delivers end-to-end medical billing services aligned with U.S. payer rules, CPT and ICD-10 coding standards, and HIPAA compliance. We support clinics and physician practices with claim submission, denial management, AR follow-up, and payment posting."
                    }
                  },

                  {
                    "@type": "Question",
                    "name": "How do your medical billing services reduce claim denials?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We combine front-end insurance verification, multi-level claim scrubbing, and daily denial management. Claims are manually reviewed before submission, and any denials are corrected within 24 hours to improve first-pass acceptance and reduce revenue leakage."
                    }
                  },

                  {
                    "@type": "Question",
                    "name": "Which specialties do you support in the USA?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "AcerHealth supports multiple U.S. specialties including primary care, internal medicine, cardiology, orthopedics, behavioral health, urgent care, and multi-specialty groups with workflows customized to each specialty’s payer requirements."
                    }
                  },

                  {
                    "@type": "Question",
                    "name": "How fast are claims submitted and followed up?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "All clean claims are submitted within 24 hours. Unpaid claims are followed up after 14 days, and denied claims are reworked within 24 hours to maintain steady cash flow and low A/R days."
                    }
                  },

                  {
                    "@type": "Question",
                    "name": "Is your medical billing HIPAA compliant?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. Our medical billing services follow strict HIPAA security standards, encrypted data exchange, role-based access, and compliant clearinghouse integrations to protect patient information."
                    }
                  },

                  {
                    "@type": "Question",
                    "name": "Can you handle transition from my current billing company?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We manage full onboarding including EHR configuration, data migration, open AR takeover, and payer enrollment to ensure a seamless transition without disrupting reimbursements."
                    }
                  }

                ]
              }

            ]
          }

          )}
        </script>
      </Helmet>
      {/* <BreadCrumbs Breadcrumb ={Breadcrumb} /> */}
      <Banner BannerTitle={BannerTitle} />
      <Info />
      <Desc />
      <DownContact DownContactTitle={DownContactTitle} />

    </>
  );
};

export default MedicalBillingService;